import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'error-messages:api-call-rate-limited': {
    id: 'error-messages:api-call-rate-limited',
    defaultMessage: "You've recently made too many attempts to make a change. Please try again later.",
    description: 'Rate limiting error message',
  },
});
